import { createSelector } from '@reduxjs/toolkit';

import { selectAccountSlug, selectDeskId } from '@/redux/session/selectors';
import { RootState } from '@/shared/types/state';

import { selectSideBarOpen, selectViewTitle } from './selectors';

/**
 * Combined selector for Nav component state
 */
export const selectNavState = createSelector(
  [selectAccountSlug, selectDeskId, selectSideBarOpen, selectViewTitle],
  (slug, deskId, sideBarOpen, viewTitle) => ({ slug, deskId, sideBarOpen, viewTitle })
);

/**
 * Memoized selector for all Nav-related Redux state
 */
export const selectNavReduxState = (state: RootState) => selectNavState(state);
